import React, { useState } from "react";
import Breadcrumbs from "../../core/breadcrumbs";
import { Link } from "react-router-dom";
import { Filter, Sliders } from "react-feather";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import Select from "react-select";
import { Globe, User } from "react-feather";
import Table from "../../core/pagination/datatable";
import CustomerModal from "../../core/modals/peoples/customerModal";
// import Swal from "sweetalert2";
// import withReactContent from "sweetalert2-react-content";
import useCustomer from "../../controllers/useCustomer";
import EditCustomerModal from "../../core/modals/peoples/editCustomerModal";
import Createpayment from "./createpayment";
import Showpayment from "./showpayment";
import Updatepayment from "./updatepayment";
import closeModal from "../../common/closeModal";
import usePermissions from "../../core/hooks/usePermissions";
import { getCities } from "../../utils/country";
import { currencyFormatter, formatPhoneNumber } from "../../utils/helperFunctions";

const Customers = () => {
  const [selectedRep, setSelectedRep] = useState(null);
  const [selectedState, setSelectedState] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);

  const { canAdd, canEdit, canDelete } = usePermissions();
  const {
    values: {
      allCustomer,
      total,
      loading,
      search,
      pageValues,
      states,
      representatives,
    },
    functions: { refetch, onChange, handlePageChange, downloadSheet },
  } = useCustomer(selectedRep, selectedState, selectedCity);
  const [selectedRow, setSelectedRow] = useState(null);

  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const [showModal, setShowModal] = useState(false);
  const [cityOptions, setCityOptions] = useState([]);
  const [selectedCustomerId, setSelectedCustomerId] = useState(null);
  const [selectedPaymentRow, setSelectedPaymentRow] = useState(null);

  // const handleEdit = (rowData) => {
  //   setSelectedPaymentRow(rowData);
  //   closeModal("showpayment");
  //   setShowModal(true);
  // };

  console.log("cityOptions", cityOptions);

  const handleEdit = (rowData) => {
    console.log("Editing Payment:", rowData);
    setSelectedPaymentRow(rowData);
    closeModal("showpayment");
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setSelectedPaymentRow(null);
    setShowModal(false);
  };

  const options = [
    { value: "sortByDate", label: "Sort by Date" },
    { value: "140923", label: "14 09 23" },
    { value: "110923", label: "11 09 23" },
  ];
  // const optionsTwo = [
  //   { label: "Choose Customer Name", value: "" },
  //   { label: "Benjamin", value: "Benjamin" },
  //   { label: "Ellen", value: "Ellen" },
  //   { label: "Freda", value: "Freda" },
  //   { label: "Kaitlin", value: "Kaitlin" },
  // ];

  // const countries = [
  //   { label: "Choose Country", value: "" },
  //   { label: "India", value: "India" },
  //   { label: "USA", value: "USA" },
  // ];

  // const handlePaymentList = (customerId) => {
  //   showPayment(customerId);
  // };

  const handleActionClick = (record, action) => {
    if (action === "edit") {
      setSelectedRow(record);
    } else if (action === "showPayments") {
      setSelectedCustomerId(record.id);
    } else if (action === "createPayment") {
      setSelectedRow(record);
    }
  };

  const columns = [
    {
      title: "Customer Name",
      dataIndex: "full_name",
    },
    {
      title: "Phone",
      dataIndex: "phone",
      render: (phone) => formatPhoneNumber(phone),
    },
    {
      title: "Balance",
      dataIndex: "balance",
      render: (balance) => currencyFormatter(balance),
    },
    {
      title: "State",
      dataIndex: "state",
      render: (text, record) => record?.business?.[0]?.address?.state || "N/A",
    },
    {
      title: "City",
      dataIndex: "city",
      render: (text, record) => record?.business?.[0]?.address?.city || "N/A",
    },
    {
      title: "Representative",
      dataIndex: "full_name",
      render: (text, record) => record?.user?.full_name || "N/A",
    },
    ...(canEdit || canDelete
      ? [
        {
          title: "Action",
          dataIndex: "action",
          render: (text, record) => (
            <div className="text-center position-relative">
              <div className="text-center">
                <Link
                  className="action-set"
                  to="#"
                  data-bs-toggle="dropdown"
                  aria-expanded="true"
                >
                  <i className="fa fa-ellipsis-v" aria-hidden="true"></i>
                </Link>
                <ul className="dropdown-menu">
                  <li>
                    <Link
                      to="#"
                      className="dropdown-item"
                      data-bs-toggle="modal"
                      data-bs-target="#edit-units"
                      onClick={() => handleActionClick(record, "edit")}
                    // onClick={() => {
                    //   setSelectedRow(record);
                    //   setOpenDropdownId(null);
                    // }}
                    >
                      <i
                        data-feather="edit"
                        className="feather-edit me-2"
                      ></i>
                      Edit Customer
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="#"
                      className="dropdown-item"
                      data-bs-toggle="modal"
                      data-bs-target="#showpayment"
                      onClick={() =>
                        handleActionClick(record, "showPayments")
                      }
                    // onClick={() => {
                    //   setSelectedCustomerId(record.id);
                    //   setOpenDropdownId(null);
                    // }}
                    >
                      <i className="feather-dollar-sign"></i> Show Payments
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="#"
                      className="dropdown-item"
                      data-bs-toggle="modal"
                      data-bs-target="#createpayment"
                      onClick={() =>
                        handleActionClick(record, "createPayment")
                      }
                    // onClick={() => {
                    //   setSelectedRow(record);
                    //   setOpenDropdownId(null);
                    // }}
                    >
                      <i className="feather-plus-circle me-2"></i> Create
                      Payment
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="dropdown-item"
                      onClick={() => downloadSheet(record.id)}
                    >
                      <i className="feather-download me-2"></i> Download Sheet
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          ),
        },
      ]
      : []),
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        <Breadcrumbs
          maintitle="Customer List"
          subtitle="Manage Your Customers"
          addButton="Add New Customer"
          canAdd={canAdd}
        />

        {/* /product list */}
        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-top">
              <div className="search-set">
                <div className="search-input">
                  <input
                    type="text"
                    placeholder="Search"
                    value={search}
                    onChange={(e) => onChange(e.target.value)}
                    className="form-control form-control-sm formsearch"
                  />
                  <Link to className="btn btn-searchset">
                    <i data-feather="search" className="feather-search" />
                  </Link>
                </div>
              </div>
              <div className="search-path">
                <Link
                  onClick={() => {
                    if (isFilterVisible) {
                      setSelectedCity(null);
                      setSelectedState(null);
                      setSelectedRep(null);
                      refetch();
                    }
                  }}
                  className={`btn btn-filter ${isFilterVisible ? "setclose" : ""
                    }`}
                  id="filter_search"
                >
                  <Filter
                    className="filter-icon"
                    onClick={toggleFilterVisibility}
                  />
                  <span onClick={toggleFilterVisibility}>
                    <ImageWithBasePath
                      src="assets/img/icons/closes.svg"
                      alt="img"
                    />
                  </span>
                </Link>
              </div>
              <div className="form-sort stylewidth">
                <Sliders className="info-img" />
                <Select
                  classNamePrefix="react-select"
                  className="img-select"
                  options={options}
                  placeholder="Sort by Date"
                />
              </div>
            </div>
            {/* /Filter */}
            <div
              className={`card${isFilterVisible ? " visible" : ""}`}
              id="filter_inputs"
              style={{ display: isFilterVisible ? "block" : "none" }}
            >
              <div className="card-body pb-0">
                <div className="row">
                  <div className="col-lg-3 col-sm-6 col-12">
                    <div className="input-blocks">
                      <User className="info-img" />
                      <Select
                        options={representatives}
                        className="img-select"
                        value={selectedRep}
                        classNamePrefix="react-select"
                        placeholder="Choose Representative Name"
                        onChange={(selected) => {
                          setSelectedRep(selected);
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-sm-6 col-12">
                    <div className="input-blocks">
                      <Globe className="info-img" />
                      <Select
                        options={states}
                        className="img-select"
                        placeholder="Choose State"
                        classNamePrefix="react-select"
                        value={selectedState}
                        onChange={(selected) => {
                          setSelectedState(selected);
                          const cities = getCities("US", selected?.state_id)
                          setCityOptions(cities);
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-sm-6 col-12">
                    <div className="input-blocks">
                      <Globe className="info-img" />
                      <Select
                        options={cityOptions}
                        value={selectedCity}
                        className="img-select"
                        placeholder="Choose City"
                        classNamePrefix="react-select"
                        onChange={(selected) => {
                          setSelectedCity(selected);
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-sm-6 col-12 ms-auto">
                    {/* <div className="input-blocks">
                      <a className="btn btn-filters ms-auto">
                        {" "}
                        <i
                          data-feather="search"
                          className="feather-search"
                        />{" "}
                        Search{" "}
                      </a>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
            {/* /Filter */}
            <div className="table-responsive">
              <Table
                total={total}
                columns={columns}
                loading={loading}
                className="table datanew"
                onPageChange={handlePageChange}
                dataSource={allCustomer?.data || []}
                pagination={pageValues}
              />
            </div>
          </div>
        </div>
        {/* /product list */}
      </div>
      <CustomerModal refetch={refetch} />
      <EditCustomerModal rowData={selectedRow} refetch={refetch} />
      <Createpayment customer={selectedRow} refetch={refetch} />
      <Showpayment
        customerId={selectedCustomerId}
        onEdit={handleEdit}
        refetchCustomers={refetch}
      />
      {showModal && (
        <Updatepayment
          setShow={setShowModal}
          show={showModal}
          rowData={selectedPaymentRow}
          onClose={handleCloseModal}
        />
      )}
      {/* {selectedPaymentRow && ( */}
      {/* <Updatepayment rowData={selectedPaymentRow} onClose={handleCloseModal} /> */}
      {/* )} */}
    </div>
  );
};

export default Customers;
